/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetConsentDecisionRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {GetConsentDecisionResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const getConsentDecision = (request:GetConsentDecisionRequest, options?: CashRequestOptions) => post<GetConsentDecisionRequest, GetConsentDecisionResponse>("/2.0/cash/get-consent-decision", request, {...options, rejectOnError: true })